import { PinInput } from './PinInput'

interface PinStepProps {
  pin: string[]
  setPin: React.Dispatch<React.SetStateAction<string[]>>
}

export function PinStep({ pin, setPin }: PinStepProps) {
  return (
    <div className="space-y-2 pt-4">
      <PinInput pin={pin} setPin={setPin} />
    </div>
  )
}
